import { Type } from '@angular/core';

import { merge } from '../internals/merge';
import { getSpecDefaultOptions, SpecOptions } from '../Spec/options';
import { OptionalsRequired } from '../types';

import { HostComponent } from './host-component';

/**
 * @publicApi
 */
export interface SpecHostOptions<C, H> extends SpecOptions<C> {
  host?: Type<H>;
  template?: string;
}

const defaultSpecHostOptions: OptionalsRequired<SpecHostOptions<any, any>> = {
  ...getSpecDefaultOptions<any>(),
  host: HostComponent,
  template: ''
};

/**
 * @internal
 */
export function getSpecHostDefaultOptions<C, H>(overrides?: SpecHostOptions<C, H>): Required<SpecHostOptions<C, H>> {
  return merge(defaultSpecHostOptions, overrides);
}
